import React from 'react'
import PropTypes from 'prop-types'

const defaultMapUtils = {
  setMapCenter: () => {},
  getMapCenterAddress: () => {}
}

// addressUtils: helper functions for addresses (i.e. to get lat & lng of an address). This's necessary since each map service has different address object.
// mapUtils: helper functions to control/manipulate maps (i.e. to get/set center position of map)
// mapApi: to call map service REST api (i.e. reverse geocode api, get address from query)
// MapComponent: the map component to render

export class MapResource extends React.PureComponent {
  static propTypes = {
    MapComponent: PropTypes.func,
    getCurrentAddress: PropTypes.func,
    getTimezoneFromLatLon: PropTypes.func,
    findPlaceFromQuery: PropTypes.func,
    reverseGeoCode: PropTypes.func,
    getPlaceDetails: PropTypes.func,
    mapServices: PropTypes.any,
    MapServiceLogo: PropTypes.element
  }

  static defaultProps = {
    getCurrentAddress: () => ({}),
    findPlaceFromQuery: () => ({}),
    reverseGeoCode: () => ({}),
    getPlaceDetails: () => ({}),
    MapComponent: () => null,
    MapServiceLogo: null
  }

  state = {
    mapUtils: defaultMapUtils
  }

  registerMap = (map, mapUtils, callback) => this.setState({ map, mapUtils }, callback)

  unregisterMap = () => this.setState({ map: null, mapUtils: defaultMapUtils })

  getMapProps = () => ({
    registerMap: this.registerMap,
    unregisterMap: this.unregisterMap,
    mapServices: this.props.mapServices,
    mapApi: this.getMapApi()
  })

  getMapApi = () => {
    const { getCurrentAddress, getTimezoneFromLatLon, findPlaceFromQuery, reverseGeoCode, getPlaceDetails } = this.props
    return { getCurrentAddress, getTimezoneFromLatLon, findPlaceFromQuery, reverseGeoCode, getPlaceDetails }
  }

  render () {
    const { MapComponent, MapServiceLogo, children } = this.props
    const { mapUtils } = this.state

    return children({
      mapApi: this.getMapApi(),
      getMapProps: this.getMapProps,
      MapComponent,
      mapUtils,
      MapServiceLogo
    })
  }
}

export default MapResource
